import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import type { PlanDTO, PlanStatusEnumValue, FrequencyEnumValue } from '../../core/models';

@Component({
  selector: 'app-plan-read',
  templateUrl: './plan-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TagModule]
})
export class PlanReadComponent {
  plan = input.required<PlanDTO>();

  private readonly statusOptions: { value: PlanStatusEnumValue; label: string }[] = [
    { value: 'DRAFT', label: 'Borrador' },
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'ARCHIVED', label: 'Archivado' }
  ];

  private readonly frequencyOptions: { value: FrequencyEnumValue; label: string }[] = [
    { value: 'ONCE', label: 'Una vez' },
    { value: 'DAILY', label: 'Diario' },
    { value: 'WEEKLY', label: 'Semanal' },
    { value: 'BIWEEKLY', label: 'Quincenal' },
    { value: 'MONTHLY', label: 'Mensual' },
    { value: 'QUARTERLY', label: 'Trimestral' },
    { value: 'SEMIANNUALLY', label: 'Semestral' },
    { value: 'ANNUALLY', label: 'Anual' }
  ];

  getStatusLabel(status: PlanStatusEnumValue | string | undefined): string {
    if (!status) return '—';
    return this.statusOptions.find((o) => o.value === status)?.label ?? String(status);
  }

  getStatusSeverity(status: PlanStatusEnumValue | string | undefined): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
    switch (status) {
      case 'ACTIVE': return 'success';
      case 'DRAFT': return 'info';
      case 'ARCHIVED': return 'secondary';
      default: return 'secondary';
    }
  }

  getFrequencyLabel(freq: FrequencyEnumValue | string | undefined): string {
    if (!freq) return '—';
    return this.frequencyOptions.find((o) => o.value === freq)?.label ?? String(freq);
  }
}
